export default __webpack_public_path__ + "static/media/bg.4d3adff9.png";